export enum TemplateType {
    VWR = 'VWR',
}
